// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginPage_loginForm__jc0-I"};